import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";

export interface SpaceCardButtonsLoggedOutUserProps {
  isPrivate: boolean;
  joinSpace: () => void;
  lockedButtonLabel: string;
  lockedButtonURL: string;
}

export const SpaceCardButtonsLoggedOutUser = ({
  isPrivate,
  lockedButtonLabel,
  lockedButtonURL,
  joinSpace,
}: SpaceCardButtonsLoggedOutUserProps) => {
  const shouldShowLockedButton =
    isPrivate && lockedButtonLabel && lockedButtonURL;

  const onClickLocked = () => {
    window.location.assign(lockedButtonURL);
  };

  if (!isPrivate) {
    return (
      <Button type="button" variant="primary" onClick={joinSpace}>
        {t("join_space")}
      </Button>
    );
  }

  if (shouldShowLockedButton) {
    return (
      <Button type="button" variant="secondary" onClick={onClickLocked}>
        {lockedButtonLabel}
      </Button>
    );
  }

  return null;
};
